module.exports = __webpack_public_path__ + "img/slider-thumb.24498672.jpg";